// auth
import {invalidEducatorEmail} from 'auth/utils';

// shared
import req from 'shared/req';
import {errorMessage} from 'shared/actions/notifications';
import {parseQueryString} from 'shared/utils';
import GoogleOAuth from 'shared/modules/google-oauth';

export const onSubmit = (values) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    return req({
      url: '/v1/basic/signup?fields=_id',
      method: 'post',
      data: {
        ...getData(getState),
        ...values
      }
    }).then((res) => {
      window.location = res.url;
      resolve();
    }).catch((data) => {
      const errors = {};

      data.forEach((error) => {
        switch (error.type) {
          case 'BasicLoginInvalidEmail':
          case 'BasicSignupInvalidEmail':
          case 'BasicSignupTakenEmail':
          case 'BasicSignupInvalidMobile':
          case 'BasicSignupTakenMobile':
          case 'BasicSignupEmailHostInvalid':
            errors.identifier = error.message;
            break;
          case 'BasicSignupInvalidPassword':
            errors.password = error.message;
            break;
          case 'BasicLoginInvalidUserType':
            errors.identifier = 'This feature is only available to students. Sorry!';
            break;
        }
      });

      reject(errors);
    });
  });
};

export const googleSignUp = () => (dispatch, getState) => {
  const data = getData(getState);

  GoogleOAuth.authorize().then((googleUser) => {
    const googleEmail = googleUser.getBasicProfile().getEmail();

    if (data.user_type === 'educator' && invalidEducatorEmail(googleEmail)) {
      dispatch(errorMessage('Please use your official work email address.'));
      return;
    }

    return req({
      url: '/auth/google/signup',
      method: 'post',
      data: {
        token: googleUser.getAuthResponse().id_token,
        ...data
      }
    }).then((res) => {
      window.location = res.url;
    }).catch(() => {
      dispatch(errorMessage());
    });
  });
};

const getData = (getState) => {
  const {
    urlParameters
  } = getState();

  const {
    competition_slug,
    invite_code,
    listing_code,
    signup_form_location,
    student_invitation_id
  } = parseQueryString((urlParameters || window.location.search).slice(1));

  const {
    userType,
    userSubtype
  } = parseUserType();

  return {
    user_type: userType,
    user_subtype: userSubtype,
    cookie: true,
    referral: {
      signup_form_location,
      invite_code,
      listing_code,
      competition_slug,
      student_invitation_id
    }
  };
};

const parseUserType = () => {
  const user = {};
  const urlParams = window.location.pathname.slice(1).split('/');

  user.userType = urlParams[1];
  user.userSubtype = urlParams[2] || null;

  return user;
};
